module.exports = function(h, row) {
    return (
        <div>
            <label class="md-check">
                <input
                    type="checkbox"
                    onChange={e =>
                        this.onChangeOutletSelectAll(e.target.checked)
                    }
                />
                <i class="indigo" />
            </label>
        </div>
    );
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/tax/add-outlets-select-all.jsx